<table mat-table class="services-table" [dataSource]="manageableTableConfig.data">

    <ng-container *ngFor="let group of manageableTableConfig.groups; let firstGroup = first; let lastGroup = last;">
        <!-- FIRST ROW TEMPLATE : all the cells that contains the groups labels -->
        <div [matColumnDef]="group.name" [sticky]="firstGroup">
            <th mat-header-cell
                *matHeaderCellDef
                [attr.colspan]="group.columns.length"
                class="group-header"
                [class.data-cell]="!firstGroup"
                [class.main-cell]="firstGroup"
                [class.last-column-of-group-cell]="!lastGroup">
                <div class="group-name">
                    <btn *ngIf="!firstGroup; else firstColumnHeader"
                         class="group-button"
                         [label]="getGroupName(group.name)"
                         type="actionLink"
                         (click)="toggleGroup(group.name)">
                        <fa-icon class="icon-end icon-information"
                                 [icon]="groupsParams[group.name].show ? iconAngleDown : iconAngleRight"></fa-icon>
                    </btn>
                    <ng-template #firstColumnHeader>{{ group.name }}</ng-template>
                </div>
            </th>
        </div>

        <!-- OTHER ROWS TEMPLATE : all the cells that contains the services header AND datas -->
        <div *ngFor="let column of group.columns; let firstGroupColumn = first; let lastGroupColumn = last;">
            <div [matColumnDef]="column.columnDef" [sticky]="firstGroup">
                <!-- Services headers row -->
                <td mat-header-cell
                    *matHeaderCellDef
                    [class.data-cell]="!firstGroup"
                    [class.main-cell]="firstGroup"
                    [class.last-column-of-group-cell]="lastGroupColumn && !lastGroup"
                    [class.clickable-header]="column.codeTranslation"
                    (click)="column.codeTranslation ? toggleCodeTranslation(column.columnDef): false">
                    <div class="column-name">
                        <strong>
                            <abbr *ngIf="column.codeTranslation; else unTranslatedHeader"
                                  [attr.title]="column.codeTranslation">{{ column.header ? column.header : "" }}</abbr>
                            <ng-template #unTranslatedHeader>{{ column.header ? column.header : "" }}</ng-template>
                            <fa-icon [icon]="iconInfoCircle" *ngIf="column.codeTranslation"></fa-icon>
                        </strong>
                        <em class="code-translation"
                            *ngIf="columnParams[column.columnDef] && columnParams[column.columnDef].showTranslation">{{ column.codeTranslation }}</em>
                    </div>
                </td>
                <!-- datas rows -->
                <td mat-cell *matCellDef="let element; let i = index"
                    [class.data-cell]="!firstGroup"
                    [class.main-cell]="firstGroup"
                    [class.last-column-of-group-cell]="lastGroupColumn && !lastGroup">

                    <div *ngIf="isString(element.get(column.columnDef).value)">
                        <strong>{{ element.get(column.columnDef).value }}</strong>
                        <fa-icon [icon]="iconInfoCircle"
                                 *ngIf="element.get(column.columnDef).info"
                                 class="icon-information"
                                 (click)="toggleDetails(i)"></fa-icon>
                        <div><em *ngIf="detailsIsOpen(i)" class="info"
                                 [innerHTML]="element.get(column.columnDef).info"></em></div>
                    </div>

                    <fa-icon [icon]="iconCheck" *ngIf="!isString(element.get(column.columnDef).value) && element.get(column.columnDef).value"></fa-icon>
                    <fa-icon
                            *ngIf="!isString(element.get(column.columnDef).value) && !element.get(column.columnDef).value && column.alertWhenMissing"
                            [icon]="iconTimes"
                            class="missing-data"></fa-icon>
                </td>
            </div>
        </div>
    </ng-container>

    <tr mat-row *matRowDef="let row; columns: columnsDef;"></tr>
    <tr mat-header-row class="groups-header-row" *matHeaderRowDef="groups"></tr>
    <tr mat-header-row class="services-header-row" *matHeaderRowDef="columnsDef"></tr>

</table>